// Select all variant elements
const variantOptions = document.querySelectorAll('product-item-variants .box--product-variant');

variantOptions.forEach(option => {
  option.addEventListener('click', () => {
    // Find the nearest product-item-variants container
    const productContainer = option.closest('.product-item');
    if (!productContainer) return; // Safety check

    // Find the primary image inside this container
    const primaryImage = productContainer.querySelector('.box--product-image.primary');
    if (primaryImage) {
      primaryImage.style.opacity = '0'; // No need for !important in JS
    }
  });
});